import axios from 'axios'
import { isAuthError, natsErrorCode } from '@omniflow/browser-bus'

/**
 * Текст ошибки входа для человека. Вход — два шага: REST `/api/v1/auth/login` выдаёт JWT, затем
 * браузер подключается к шине по WebSocket. Голый `err.message` на втором шаге бывает пустым:
 * браузерный `WebSocket` не сообщает причину сбоя, и nats.ws строит `NatsError` из пустой строки —
 * нотис выходил без текста. Поэтому шаг называется явно, а адрес шины подставляется в текст.
 */
export const describeLoginError = (err: unknown, natsWsUrl: string): string => {
  if (axios.isAxiosError(err)) {
    const status = err.response?.status
    if (status === 401) return 'Неверный логин, пароль или тенант'
    if (status === 429) return 'Слишком много попыток входа — подождите минуту'
    if (status) return `Сервер входа ответил ошибкой ${status}`
    return 'Сервер входа недоступен (сеть или прокси)'
  }
  if (isAuthError(err)) return 'Шина NATS отклонила токен — войдите ещё раз'
  const code = natsErrorCode(err)
  const detail = err instanceof Error && err.message ? err.message : code
  return `Вход выполнен, но не удалось подключиться к шине NATS (${natsWsUrl})${detail ? `: ${detail}` : ''}`
}
